exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vsg_gutter[data-v-a6ac4e44]{background-color:grey}", ""]);

// exports
